import { render, staticRenderFns } from "./codegenList.vue?vue&type=template&id=0919b70b&scoped=true"
import script from "./codegenList.vue?vue&type=script&lang=js"
export * from "./codegenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0919b70b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0919b70b')) {
      api.createRecord('0919b70b', component.options)
    } else {
      api.reload('0919b70b', component.options)
    }
    module.hot.accept("./codegenList.vue?vue&type=template&id=0919b70b&scoped=true", function () {
      api.rerender('0919b70b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/codegen/codegenList.vue"
export default component.exports